import * as React from 'react';

interface CalendarWeekHeaderProps {
  language?: 'enUS' | 'es';
}

export default function CalendarWeekHeader(props: CalendarWeekHeaderProps) {
  return (
    <div className="week">
      <span>{props.language && props.language === 'es' ? 'Do' : 'Sun'}</span>
      <span>{props.language && props.language === 'es' ? 'Lu' : 'Mon'}</span>
      <span>{props.language && props.language === 'es' ? 'Ma' : 'Tue'}</span>
      <span>{props.language && props.language === 'es' ? 'Mi' : 'Wed'}</span>
      <span>{props.language && props.language === 'es' ? 'Ju' : 'Thu'}</span>
      <span>{props.language && props.language === 'es' ? 'Vi' : 'Fri'}</span>
      <span>{props.language && props.language === 'es' ? 'Sa' : 'Sat'}</span>
    </div>
  );
}
